import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import { getAttrValue } from '@grandvisionhq/utils'
import {
  ErrorCase,
  InitialProps,
  LegacyPage,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail-legacy'
import { PromoteInstallmentsRestContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsRestContainer'
import { RxGlassesConfiguratorContainer } from '@grandvisionhq/www-next/slot-components/RxGlassesConfiguratorContainer'

import OpticianForm from '../../components/forms/Optician'
import { composePDP } from '../../components/hocs/compose-pdp'
import { settings as cartSettings } from '../../components/hocs/with-cart'
import {
  getDeliveryIndicatorConfig,
  getSpecifications,
  promoteInstallmentsConfiguration,
} from '../../configuration'
import { deliveryResolverFactory } from '../../util/delivery-resolver-factory'

const slots: Props['slots'] = {
  AfterPrice: () => (
    <PromoteInstallmentsRestContainer opcoConfiguration={promoteInstallmentsConfiguration} />
  ),
  Configurator: RxGlassesConfiguratorContainer,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const { productType } = props
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const specificationConfiguration = getSpecifications(productType)

  const maxQuantityPerVariant = Number(
    getAttrValue(props.product.masterVariant, 'maxQuantityPerVariant')
  ) // returns NaN if there is no maxQuantityPerVariant on the product

  const maxOrderableQuantity = !!maxQuantityPerVariant
    ? maxQuantityPerVariant
    : cartSettings.maximumQuantity

  return (
    <LegacyPage
      {...props}
      slots={slots}
      clAndSolutionsMaxOrderableQuantity={maxOrderableQuantity}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      deliveryResolverFactory={deliveryResolverFactory}
      opticianForm={OpticianForm}
      specificationConfiguration={specificationConfiguration}
    />
  )
}

ProductDetailPage.getInitialProps = LegacyPage.getInitialProps

export default composePDP<Props>(ProductDetailPage)
